import { useCurrentUserAllowedGroups } from './use-current-user-allowed-groups';

export function useDefaultGroup(): number | undefined {
  const groups = useCurrentUserAllowedGroups();

  return groups[0]?.id;
}
